<template>
  <div class="uk-container">
    <template v-if="!request">
      <div class="uk-alert-danger uk-width-medium uk-margin-auto uk-text-center" uk-alert>
        <p>Oops! <br> Something went wrong.</p>
      </div>
    </template>

    <template v-else>
      <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
        <div class="uk-card-header uk-text-center">
          <h3 class="uk-card-title">Request - <span style="text-transform: capitalize;">{{ request.info.type }}</span></h3>
          <p class="uk-text-meta">{{ request.id }}</p>
        </div>

        <div class="uk-card-body uk-text-center uk-padding-remove card-content">
          <template v-if="request.info.type === 'dentist'">
            <div class="section">
              <div class="section-title">Practice Info</div>
              <div class="section-content">
                <div class="item">
                  <div class="item-title">Dentist Name</div>
                  <div class="item-content">
                    {{ request.content.form.name }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">Notifications Email</div>
                  <div class="item-content">
                    {{ request.content.form.email }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">Phone Number <br> Practice</div>
                  <div class="item-content">
                    {{ request.content.form.phone.primary }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">Phone Number <br> On-Call</div>
                  <div class="item-content">
                    {{ request.content.form.phone.secondary }}
                  </div>
                </div>
              </div>
            </div>

            <div class="section">
              <div class="section-title">Practice Location</div>
              <div class="section-content">
                <div class="item">
                  <div class="item-title">House Number/Name</div>
                  <div class="item-content">
                    {{ request.content.form.location.house }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">Street Name</div>
                  <div class="item-content">
                    {{ request.content.form.location.street }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">City/Town</div>
                  <div class="item-content">
                    {{ request.content.form.location.city }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">Postcode</div>
                  <div class="item-content">
                    {{ request.content.form.location.postcode }}
                  </div>
                </div>
              </div>
            </div>

            <div class="section">
              <div class="section-title">Features</div>
              <div class="section-content">
                <template v-for="feature in $helpers.practiceFeatures">
                  <div :key="feature.id" class="item">
                    <div class="item-title">
                      {{ feature.value }}
                    </div>
                    <div class="item-content">
                      <b>Status</b>: {{ (request.content.form.features[feature.id].status) ? 'Yes' : 'No' }}<br>
                      <template v-if="request.content.form.features[feature.id].notes">
                        <b>Notes</b>: {{ request.content.form.features[feature.id].notes }}
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div class="section">
              <div class="section-title">Notifications</div>
              <div class="section-content">
                <div class="item">
                  <div class="item-title">Email</div>
                  <div class="item-content">
                    {{ request.content.form.notifications.email ? 'Yes' : 'No' }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-title">SMS</div>
                  <div class="item-content">
                    {{ request.content.form.notifications.sms ? 'Yes' : 'No' }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div v-if="request.info.type === 'refund'" class="section">
            <div class="section-title">Refund Details</div>
            <div class="section-content">
              <div class="item">
                <div class="item-title">Type</div>
                <div class="item-content">
                  <span style="text-transform: capitalize;">{{ request.content.type }}</span>
                </div>
              </div>
              <div class="item">
                <div class="item-title">Reason</div>
                <div class="item-content">
                  {{ request.content.reason }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">Value</div>
                <div class="item-content">
                  £{{ request.content.value|price }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">Appointment ID</div>
                <div class="item-content">
                  {{ request.content.appointmentId }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">Refund ID</div>
                <div class="item-content">
                  {{ request.content.refundId }}
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="section-title">Info</div>
            <div class="section-content">
              <div class="item">
                <div class="item-title">Status</div>
                <div class="item-content" v-html="formatStatus(request.info.status)" />
              </div>
              <div class="item">
                <div class="item-title">Created</div>
                <div class="item-content">
                  {{ $moment(request.info.created.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss') }}
                </div>
              </div>
              <div class="item">
                <div class="item-title">Updated</div>
                <div class="item-content">
                  {{ request.info.updated && request.info.updated.timestamp ? $moment(request.info.updated.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss') : 'N/A' }}
                </div>
              </div>
              <!-- <div class="item">
                <div class="item-title">User</div>
                <div class="item-content">
                  {{ user.name.first }} {{ user.name.last }}
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-warning uk-margin-right" :disabled="request.info.status === 'progress'" @click="setStatus('progress')">In Progress</button>
          <button class="uk-button uk-button-primary" :disabled="request.info.status === 'resolved'" @click="setStatus('resolved')">Resolved</button>
        </div>
      </div>

      <div class="uk-margin-top history">
        <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title">History</h3>
            <p class="uk-text-meta">Logs - User Actions</p>
          </div>

          <div class="uk-card-body uk-padding-remove uk-text-center actions">
            <div v-for="(action, index) in actions" :key="index" class="action">
              <div class="description" :class="{ hover: action.details }">
                <div class="message">
                  {{ action.message.primary }}

                  <template v-if="action.message.secondary">
                    <span v-html="action.message.secondary" />
                  </template>
                </div>

                <div class="info uk-text-meta">
                  <span :uk-tooltip="`title: ${action.info.timestamp.default}; pos: bottom;`">{{ action.info.timestamp.human }}</span> - <b>{{ action.info.user }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'ViewRequestSingle',

  filters: {
    // Format Price
    price: (value) => {
      if (!value) return ''

      const price = value.toString()
      return `${price.slice(0, value.length - 2)}.${price.slice(price.length - 2, price.length)}`
    }
  },

  computed: {
    request() {
      return this.$store.getters['requests/find'](this.$route.params.id)
    },

    // user() {
    //   return this.$store.getters['users/find'](this.request.info.created.user)
    // },

    actions() {
      const actions = []
      // Slice is used to make a shallow copy of an array to prevent state mutation and infinite loop.
      const log = this.request.log.slice().reverse()

      log.forEach((action) => {
        const { type } = action
        const user = this.getUser(action.user)
        const message = {}
        const info = {
          timestamp: {
            human: this.$moment(action.timestamp.seconds, 'X').fromNow(),
            default: this.$moment(action.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss')
          },
          user
        }

        if (type === 'create') {
          message.primary = 'Request was created.'
        }

        if (type === 'update') {
          if (action.subtype && action.subtype === 'status') {
            const status = this.$helpers.status.request.find((option) => option.id === action.content)

            message.primary = 'Request status was updated to'
            message.secondary = `<b>${status.value}</b>.`
          }

          if (action.subtype && action.subtype === 'convert') {
            message.primary = 'Request was converted to Appointment.'
          }
        }


        actions.push({ info, message })
      })

      return actions
    }
  },

  methods: {
    getUser(id) {
      const user = this.$store.getters['users/find'](id)
      return (user) ? `${user.name.first} ${user.name.last}` : 'Web'
    },

    formatStatus(data) {
      let label = '<div class="uk-label uk-label-danger">N/A</div>'
      const option = this.$helpers.status.request.find((o) => o.id === data)
      label = `<div class="uk-label uk-label-${option.class}">${option.value}</div>`
      return label
    },

    async setStatus(status) {
      const loader = this.$loader.show()
      const request = {
        'info.status': status,
        'info.updated': {
          timestamp: this.$firebase.firestore.FieldValue.serverTimestamp(),
          user: this.$store.state.account.record.uid
        },
        log: this.$firebase.firestore.FieldValue.arrayUnion({
          timestamp: this.$firebase.firestore.Timestamp.now(),
          user: this.$store.state.account.record.uid,
          type: 'update',
          subtype: 'status',
          content: status
        })
      }

      try {
        if (this.request.info.type === 'dentist' && status === 'resolved') {
          await this.$firebase.firestore().collection(this.$globals.firebase.collection.dentists).doc(this.request.content.dentist).update({ request: false })
        }

        if (this.request.info.type === 'refund') {
          await this.$firebase.firestore().collection(this.$globals.firebase.collection.appointments).doc(this.request.content.appointmentId).update({ [`refund.${this.request.content.refundId}.status`]: status })
        }

        await this.$firebase.firestore().collection(this.$globals.firebase.collection.requests).doc(this.request.id).update(request)
        this.$uikit.notification('The request was updated successfully!', 'success')
      } catch (error) {
        console.log(error)
        this.$uikit.notification('Something went wrong while submitting the request update. Please try again later, or contact support.', 'danger')
      } finally {
        loader.hide()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content .section .section-content .item .item-title {
  width: 170px;
}
</style>
